import styled from "styled-components"

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export default TitleWrapper
